<div class="container-fluid h-100">
	<div class="row h-100 justify-content-center align-items-center">
		<div class="col-6 text-center">
			<!-- <div><i class="fa fa-bug"></i><span>404</span></div>
				<h1>Page not found</h1>
				<h2>We're sorry, the page you requested could not be found. Please go back to the <a href="/">homepage</a> or
					contact us at <a href="mailto:it.helpdesk@paramountenterprise.co.id">it.helpdesk@paramountenterprise.co.id</a>.</h2> -->
			<div class="row justify-content-center">
				<div class="col-10">
					<thumb [src]="apiUrl + '/images/error-401.jpg'" height="450px"></thumb>
				</div>
			</div>
			<h1>Unauthorized Access</h1>
			<h2>We're sorry, you are not allowed to access this page. <br>Please go back to <a href="/">homepage</a>
				<br>or contact us at <a
					href="mailto:it.helpdesk@paramountenterprise.co.id">it.helpdesk&#64;paramountenterprise.co.id</a>.
			</h2>
		</div>
	</div>
</div>